module.exports = __webpack_public_path__ + "static/img/stoneCarving.d2faea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stoneCarving.png
// module id = Fn4H
// module chunks = 26